import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import FeatureIcon01 from '../../images/feature-icon-01.svg'
import FeatureIcon02 from '../../images/feature-icon-02.svg'
import FeatureIcon03 from '../../images/feature-icon-03.svg'
import FeatureIcon04 from '../../images/feature-icon-04.svg'
import FeatureIcon05 from '../../images/feature-icon-05.svg'
import FeatureIcon06 from '../../images/feature-icon-06.svg'
import { db } from '../../firebase';
import { collection, doc, getDocs, getDoc, addDoc, updateDoc, deleteDoc } from 'firebase/firestore';
import { faqs } from '../../db';
import FaqCard from '../../components/FaqCard';
import EventSection from '../../components/EventSection';
import Tilt from 'react-parallax-tilt';
import { Globe } from '../../components';



const Home = () => {

  const usersCollectionsRef = collection(db, "users");
  const clientsCollectionsRef = collection(db, "clients");


  const createUser = async () => {
    const res = await addDoc(usersCollectionsRef, {
      name: "",
      email: ""
    });
  };

  const getUsers = async () => {
    const data = await getDocs(usersCollectionsRef);
    const res = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
  };

  const getSingleUser = async (id) => {
    const userDoc = doc(db, "users", id)
    const docSnap = await getDoc(userDoc);
    const res = docSnap.data()
  };

  const updateUser = async (id) => {
    const userDoc = doc(db, "users", id)
    const res = await updateDoc(userDoc, {
      name: ""
    });
  };

  const deleteUser = async (id) => {
    const userDoc = doc(db, "users", id)
    const res = await deleteDoc(userDoc);
  };

  const getClients = async () => {
    try {
      const data = await getDocs(clientsCollectionsRef);

      console.log('data=========>', data)

      const res = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
      // console.log('res=========>', res)
    } catch (error) {
      console.log('error=========>', error)

    }
  };


  useEffect(async () => {
    // const querySnapshot = await getDocs(collection(db, "clients"));
    // console.log('querySnapshot===============>', querySnapshot)
  }, [])

  return (
    <div className="body-wrap">
      <section className="hero">
        <div className="container">
          <div className="hero-inner">
            <div className="hero-copy">
              <h1 className="hero-title">Why Host A Virtual Benefits Fair?</h1>
              <p className="hero-paragraph text-sm mb-0">Lorem ipsum dolor sit amet consectetur adipisicing elit. Dignissimos non debitis rem blanditiis fugit quaerat mollitia quibusdam voluptas ea minus perferendis harum eius illum, quia sed optio? Quod, molestiae voluptate.</p>
              <br /><br />
              <div className="hero-cta">
                <Link to="/fairs" className="button button-primary">View All Fairs</Link>
                <Link to="/fairs?type=live" className="button">Ongoing Fairs</Link>
              </div> 
            </div>

            <div className="globe">
            <Globe />
            </div>



            <div className="hero-figure anime-element">
              <svg className="placeholder" width={528} height={396} viewBox="0 0 528 396">
                <rect width={528} height={396} style={{ fill: 'transparent' }} />
              </svg>
              {/* <div className="hero-figure-box hero-figure-box-01" data-rotation="45deg" /> */}
              {/* <div className="hero-figure-box hero-figure-box-02" data-rotation="-45deg" /> */}
              {/* <div className="hero-figure-box hero-figure-box-03" data-rotation="0deg" /> */}
              {/* <div className="hero-figure-box hero-figure-box-04" data-rotation="-135deg" /> */}
              {/* <div className="hero-figure-box hero-figure-box-05" /> */}
              {/* <div className="hero-figure-box hero-figure-box-06" /> */}
              <div className="hero-figure-box hero-figure-box-07" />
              {/* <div className="hero-figure-box hero-figure-box-08" data-rotation="-22deg" /> */}
              {/* <div className="hero-figure-box hero-figure-box-09" data-rotation="-52deg" /> */}
              <div className="hero-figure-box hero-figure-box-10" data-rotation="-50deg" />
            </div>
          </div>
        </div>
      </section>
      <section className="features section">





        <div className="container">
          <div className="features-inner section-inner has-bottom-divider">
            <br /><br /><br /><br />
            <div className="pricing-header text-center">
              <h2 className="section-title mt-0">Why HiFair ?</h2>
              <p className="section-paragraph mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut ad quis nostrud.</p>
            </div>


            <div className="features-wrap">
              <div className="feature text-center is-revealing">
                <div className="feature-inner">
                  <div className="feature-icon">
                    <img src={FeatureIcon01} alt="Feature 01" />
                  </div>
                  <h4 className="feature-title mt-24">24x7 Global Support</h4>
                  <p className="text-sm mb-0">Fermentum posuere urna nec tincidunt praesent semper feugiat nibh. A arcu cursus vitae congue mauris. Nam at lectus urna duis convallis. Mauris rhoncus aenean vel elit scelerisque mauris.</p>
                </div>
              </div>
              <div className="feature text-center is-revealing">
                <div className="feature-inner">
                  <div className="feature-icon">
                    <img src={FeatureIcon02} alt="Feature 02" />
                  </div>
                  <h4 className="feature-title mt-24">End-To-End Customization</h4>
                  <p className="text-sm mb-0">Fermentum posuere urna nec tincidunt praesent semper feugiat nibh. A arcu cursus vitae congue mauris. Nam at lectus urna duis convallis. Mauris rhoncus aenean vel elit scelerisque mauris.</p>
                </div>
              </div>
              <div className="feature text-center is-revealing">
                <div className="feature-inner">
                  <div className="feature-icon">
                    <img src={FeatureIcon03} alt="Feature 03" />
                  </div>
                  <h4 className="feature-title mt-24">Turnkey Event Management</h4>
                  <p className="text-sm mb-0">Fermentum posuere urna nec tincidunt praesent semper feugiat nibh. A arcu cursus vitae congue mauris. Nam at lectus urna duis convallis. Mauris rhoncus aenean vel elit scelerisque mauris.</p>
                </div>
              </div>
              <div className="feature text-center is-revealing">
                <div className="feature-inner">
                  <div className="feature-icon">
                    <img src={FeatureIcon04} alt="Feature 04" />
                  </div>
                  <h4 className="feature-title mt-24">Global Clientele</h4>
                  <p className="text-sm mb-0">Fermentum posuere urna nec tincidunt praesent semper feugiat nibh. A arcu cursus vitae congue mauris. Nam at lectus urna duis convallis. Mauris rhoncus aenean vel elit scelerisque mauris.</p>
                </div>
              </div>
              <div className="feature text-center is-revealing">
                <div className="feature-inner">
                  <div className="feature-icon">
                    <img src={FeatureIcon05} alt="Feature 05" />
                  </div>
                  <h4 className="feature-title mt-24">Fast-track Project Delivery</h4>
                  <p className="text-sm mb-0">Fermentum posuere urna nec tincidunt praesent semper feugiat nibh. A arcu cursus vitae congue mauris. Nam at lectus urna duis convallis. Mauris rhoncus aenean vel elit scelerisque mauris.</p>
                </div>
              </div>
              <div className="feature text-center is-revealing">
                <div className="feature-inner">
                  <div className="feature-icon">
                    <img src={FeatureIcon06} alt="Feature 06" />
                  </div>
                  <h4 className="feature-title mt-24">Post-event Support</h4>
                  <p className="text-sm mb-0">Fermentum posuere urna nec tincidunt praesent semper feugiat nibh. A arcu cursus vitae congue mauris. Nam at lectus urna duis convallis. Mauris rhoncus aenean vel elit scelerisque mauris.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="features section">
        <div className="container">
          <EventSection />
        </div>
      </section>



      <section className="pricing section">
        <div className="container-sm">
          <div className="pricing-inner section-inner">
            <div className="pricing-header text-center">
              <h2 className="section-title mt-0">Unlimited for all</h2>
              <p className="section-paragraph mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut ad quis nostrud.</p>
            </div>
            <div className="pricing-tables-wrap">


              <div className="pricing-table">
                <div className="pricing-table-inner is-revealing">
                  <div className="pricing-table-main">
                    <div className="pricing-table-header pb-24">
                      <div className="pricing-table-price"><span className="pricing-table-price-currency h2">$</span><span className="pricing-table-price-amount h1">49</span><span className="text-xs">/month</span></div>
                    </div>
                    <div className="pricing-table-features-title text-xs pt-24 pb-24">What you will get</div>
                    <ul className="pricing-table-features list-reset text-xs">
                      <li>
                        <span>Lorem ipsum dolor sit nisi</span>
                      </li>
                      <li>
                        <span>Lorem ipsum dolor sit nisi</span>
                      </li>
                      <li>
                        <span>Lorem ipsum dolor sit nisi</span>
                      </li>
                      <li>
                        <span>Lorem ipsum dolor sit nisi</span>
                      </li>
                    </ul>
                  </div>
                  <div className="pricing-table-cta mb-8">
                    <a className="button button-primary button-shadow button-block" href="#">Pre order now</a>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>




      {/* <section>
        <h2>HiFair Is Your One-stop Solution That Includes Endless Opportunities.</h2>
        <ul>
          <li>100% Customizable Interface</li>
          <li>24/7 Customer Support</li>
          <li>Remarkable 3D Designs</li>
          <li>Most Trusted And Secure Platform</li>
        </ul>
      </section>


      <section>
        <h2>What Do You Get To Explore In The Demo?</h2>
        <ul>
          <li>A comprehensive view of our all-in-one virtual platform</li>
          <li>Attendee engagement suggestions</li>
          <li>Networking tips and tricks</li>
          <li>Branding and exhibiting options</li>
          <li>Various use cases of the platform</li>
          <li>A live ongoing session demo</li>
        </ul>
      </section>


      <section>
        <h2>HERE’S WHAT OUR CUSTOMERS SAY ABOUT US</h2>
      </section>



      <section>
        <h2>Why Hifair?</h2>
        <p>Here are a few reasons why HiFair needs to be your go-to Virtual Event platform when hosting virtual Trade Shows.</p>
        <u>
          <li>24x7 Global Support</li>
          <li>End-To-End Customization</li>
          <li>Turnkey Event Management</li>
          <li>Global Clientele</li>
          <li>Fast-track Project Delivery</li>
          <li>Post-event Support</li>
        </u>
      </section> */}


      <section>
        <div className="container">
          <div className="pricing-header text-center">
            <h2 className="section-title mt-0">Virtual Fairs Platform FAQs</h2>
            <p className="section-paragraph mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut ad quis nostrud.</p>
          </div>

          {faqs.length > 0 &&
            faqs.map(faq => <FaqCard faq={faq} key={faq.id} />)
          }
          <div>

          </div>
        </div>
      </section>

      <section className="cta section">
        <div className="container">
          <div className="cta-inner section-inner">
            <h3 className="section-title mt-0">Still not convinced on buying?</h3>
            <div className="cta-cta">
              <a className="button button-primary button-wide-mobile" href="#">Get in touch</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Home;